import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery } from '@utils/styledTheme.util';

export const OurStoryWrapper = styled(Box)`
  position: relative;
`;

export const StoryAssetsWrapper = styled(Box)`
  transform: translate(0px, 0%);
  position: absolute;
  top: -150px;
  width: 100%;
  z-index: 1;
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
`;

export const StoryWrapper = styled(Box)`
  position: relative;
  margin: auto;
  width: 460px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
  @media screen and (min-width: 36rem) {
    width: 460px;
  }
`;

export const GradientBlobBox = styled(Box)`
  position: absolute;
  top: 40vh;
  left: 0;
  ${themeMediaQuery('below_sm')} {
    top: 935px;
    z-index: -1;
    img {
      width: 60%;
    }
  }
  ${themeMediaQuery('sm')} {
    top: 53vh;
  }
  ${themeMediaQuery('md')} {
    top: 40vh;
  }
`;

export const GoldSquareBox = styled(Box)`
  position: absolute;
  top: 48vh;
  left: 8%;
  width: 44px;
  height: 44px;
  ${themeMediaQuery('sm')} {
    top: 65vh;
  }
  ${themeMediaQuery('md')} {
    top: 48vh;
  }
`;

export const BlobBox = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  max-width: 275px;
  width: 20%;
  ${themeMediaQuery('below_sm')} {
    top: -20vw;
    width: 43vw;
    max-width: initial;
    z-index: -2;
    transform: rotateX(180deg);
  }
  ${themeMediaQuery('sm')} {
    width: 22%;
  }
  @media (min-width: 1400px) {
    width: 20%;
  }
`;

export const CurlBox = styled(Box)`
  position: absolute;
  top: 500px;
  right: 0;
  max-width: 300px;
  z-index: 2;
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  ${themeMediaQuery('below_sm')} {
    top: -45vw;
    right: 17vw;
    transform: rotate(250deg);
    width: 60vw;
    max-width: initial;
    z-index: -1;
  }
`;

export const CircleBox = styled(Box)`
  position: absolute;
  width: 25px;
  height: 25px;
  top: 990px;
  right: 34vh;
  ${themeMediaQuery('sm')} {
    right: 30vh;
  }
  ${themeMediaQuery('md')} {
    right: 22vh;
  }
  @media (min-width: 1400px) {
    right: 34vh;
  }
  ${themeMediaQuery('lg')} {
    right: 38vh;
  }
  ${themeMediaQuery('xl')} {
    right: 26vh;
  }
`;

export const CenterAssetsWrapper = styled(Box)`
  position: relative;
  width: 0px;
  margin: auto;
`;

export const Pic1Box = styled(Box)`
  position: absolute;
  text-align: right;
  top: -13vh;
  left: 445px;
  width: 290px;
  height: 300px;
  z-index: 1;
  ${themeMediaQuery('sm')} {
    top: -20vh;
    left: 315px;
  }
  ${themeMediaQuery('md')} {
    top: -13vh;
    left: 445px;
  }
`;

export const Pic2Box = styled(Box)`
  position: absolute;
  text-align: right;
  top: 560px;
  left: 380px;
  width: 290px;
  height: 290px;
  border-radius: 50%;
  overflow: hidden;
  ${themeMediaQuery('sm')} {
    top: 550px;
    left: 320px;
  }
  ${themeMediaQuery('md')} {
    top: 560px;
    left: 380px;
  }
`;

export const Pic3Box = styled(Box)`
  position: absolute;
  top: 0;
  right: 304px;
  width: 250px;
  height: 250px;
`;

export const StyledStoriesPara = styled(Text)`
  max-width: 464px;
  ${themeMediaQuery('xl')} {
    max-width: 514px;
  }
`;

export const SignatureImageBox = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    z-index: 2;
    text-align: center;
    position: relative;
  }
`;

export const PersonFlex = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    width: 250px;
    margin: auto;
  }
`;

export const PersonNameText = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    .designation {
      display: block;
    }
  }
`;

export const SignatureImage = styled(CloudImage)`
  width: 220px;
  height: 107px;
`;

export const StoryPersonImageWrapper = styled(Box)`
  border-radius: 50%;
  overflow: hidden;
  width: 66px;
  height: 66px;
  z-index: 2;
`;
